import { configureStore } from "@reduxjs/toolkit";
import { AppStore } from "./app-store";

export const store = configureStore({
    reducer : {
        appStore: AppStore,
    }
})